import styled from '@emotion/styled';
import Image from 'gatsby-image';

export const HeaderImage = styled(Image)`
  max-height: 48rem;
`;
